import {
    SET_PVS,
    SET_PVS_PEDIDOS,
    SET_PV_ATUAL,
    SET_DIAS_UTEIS,
    SET_DIAS_UTEIS_ATUAL,
    SET_CURRENT_DATA_PV,
    CLEAR_CURRENT_DATA_PV,
} from '../actions/actionTypes';

const initialState = {
    data: {},
    pvs: [],
    diasUteis: {},
};

export const dataPvReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PVS:
            return {
                ...state,
                pvs: action.pvs,
            };
        case SET_PVS_PEDIDOS:
            return {
                ...state,
                pvsPedidos: action.pvs,
            };
        case CLEAR_CURRENT_DATA_PV:
            return {
                ...state,
                data: [],
            };
        case SET_CURRENT_DATA_PV:
            return {
                ...state,
                data: action.data,
            };
        case SET_PV_ATUAL:
            return {
                ...state,
                pvAtual: action.data,
            };
        case SET_DIAS_UTEIS:
            return {
                ...state,
                diasUteis: action.data,
            };
        case SET_DIAS_UTEIS_ATUAL:
            return {
                ...state,
                diasUteisAtual: action.data,
            };
        default:
            return state;
    }
};
